import { ChangeDetectorRef, Component } from '@angular/core';
import { BaseComponent } from 'app/components/base.component';
import { NavigationEnd, Router } from '@angular/router';
import { SmartQCTab, SmartQcTabRoute, TreeSmartQcTabs } from './smart-qc.const';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-smart-qc',
  templateUrl: './smart-qc.component.html',
  styleUrls: ['./smart-qc.component.css'],
})
export class SmartQcComponent extends BaseComponent {
  public treeTabs: SmartQCTab[] = TreeSmartQcTabs;
  public parentTabRoute: SmartQcTabRoute = SmartQcTabRoute.SUMMARY;
  public childTabRoute?: SmartQcTabRoute;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    protected router: Router
  ) {
    super(changeDetector, toastr, modalService);

    this.setRoute(router.url);

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setRoute(event.urlAfterRedirects);
      }
    });
  }

  setRoute(route: string) {
    const subPaths = route.split('/').slice(2);
    this.parentTabRoute = subPaths[0] as SmartQcTabRoute;
    this.childTabRoute = subPaths.join('/') as SmartQcTabRoute;
  }

  handleNavigate(tab: SmartQCTab) {
    this.router.navigate([`/smart-qc/${tab.tabRoute}`]);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/smart-qc/smart-qc.component.ts